import { Component, HostListener, Input, OnChanges, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { PATHS } from '../../../analytics/constants/analytics.constants';
import * as _ from 'underscore';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';

@Component({
	selector: 'app-timeline-chart',
	templateUrl: './timeline-chart.component.html',
	styleUrls: ['./timeline-chart.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class TimelineChartComponent extends BaseWidgetComponent implements OnInit, OnChanges, OnDestroy {
	@Input() data: any;
	@Input() customchartconfiguration: any;
	@Input() uikitresponseconfig: any;
	@Input() nodatamessage: string = 'No Data Available';
	@Input() requestwidgetdata: boolean = true;
	@Input() seriesviewconfiguration: any;
	@Input() sectiontitle: any;
	@Input() sectionclass: any;
	@Input() showNoData: boolean = false;
	@Input() filterSeries: any = false;

	public buttons = {
		days: true,
		weeks: false,
		months: false
	};
	public isR10: boolean = false;
	public nameSpace: string;
	public applyNodata: boolean = false;
	public chartdata = [];
	public chartConfig;
	public colorPalette: any;
	public radioButtonsEnabled: boolean = false;
	public selectedRadioButtonId: number;
	public currentProduct: string = undefined;
	public tooltipOptions = {
		animation: 'fade',
		arrow: true,
		duration: 750,
		dynamicTitle: true,
		position: 'top',
		scale: 'small'
	};
	private defaultChartConfig: any;
	private defaultSeriesViewConfig: any;

	private units = {
		days: [['day', [1]]],
		weeks: [['day', [7]]],
		months: [['month', [1]]]
	};
	private defaultRadioButtons: any = [];

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService);
		const productName = this.analyticsDataModel.getCurrentPath();
		this.currentProduct = productName !== PATHS.OVERVIEW ? productName : undefined;
	}

	@HostListener('window:resize', ['$event'])
	onResize(event: any): void {
		this.resetChartConfig();
	}

	ngOnInit(): void {
		this.isR10 = this.analyticsDataModel.config.version === 'R10' ? true : false;
		this.nameSpace = _.uniqueId('timeline-');
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.uikitresponseconfig = this.uikitresponseconfig ? JSON.parse(decodeURI(this.uikitresponseconfig)) : [];
		this.customchartconfiguration = this.customchartconfiguration
			? JSON.parse(decodeURI(this.customchartconfiguration))
			: {};
		this.columns = this.columnsconfig ? JSON.parse(decodeURI(this.columnsconfig)) : [];
		if (this.isR10) {
			// enable legends on permission
			if (
				this.customchartconfiguration &&
				this.customchartconfiguration.chartConfig &&
				this.customchartconfiguration.chartConfig.series
			) {
				let seriesCfg = this.customchartconfiguration.chartConfig.series;
				this.customchartconfiguration.chartConfig.series = _.filter(seriesCfg, (item) => {
					return this.analyticsDataModel.checkComponentForPermission(item);
				});
			}
		}

		// navigator series
		this.chartConfig = {
			chartConfig: this.customchartconfiguration.chartConfig,
			responseConfig: this.uikitresponseconfig
		};
		if (this.seriesviewconfiguration !== undefined) {
			this.seriesviewconfiguration = JSON.parse(decodeURI(this.seriesviewconfiguration));
			if (this.isR10) {
				// filter checkboxButtons with series object to have key_imprs depending on permission enabled...
				this.seriesviewconfiguration.checkboxButtons = this.seriesviewconfiguration.checkboxButtons.filter((o1) =>
					this.customchartconfiguration.chartConfig.series.some((o2) => o1.seriesId === o2.id)
				);
			}
			this.radioButtonsEnabled =
				this.seriesviewconfiguration &&
				this.seriesviewconfiguration.radioButtonGroup &&
				this.seriesviewconfiguration.radioButtonGroup.length > 0;
			this.selectedRadioButtonId = this.seriesviewconfiguration.defaultRadioButtonSelected;
			this.defaultRadioButtons = this.seriesviewconfiguration.radioButtonGroup;
		}
		if (this.requestwidgetdata) {
			this.requestData();
		} else {
			this.showLoad = false;
			this.hasData = true;
			this.updateChartData();
		}
		this.seriesviewconfiguration.checkboxButtons = _.filter(this.seriesviewconfiguration.checkboxButtons, (item) => {
			return this.analyticsDataModel.checkComponentForPermission(item);
		});

		// setting this to reset the config on page change or refresh
		this.defaultChartConfig = JSON.parse(JSON.stringify(this.chartConfig));
		this.defaultSeriesViewConfig = JSON.parse(JSON.stringify(this.seriesviewconfiguration));
	}

	ngOnChanges(): void {
		if (this.chartConfig) {
			this.updateChartData();
		}
		this.chartdata = [...this.chartdata];
	}

	/**
	 * reset the chart config
	 */
	resetChartConfig() {
		if (this.defaultChartConfig) {
			this.chartConfig = JSON.parse(JSON.stringify(this.defaultChartConfig));
		}

		if (this.defaultSeriesViewConfig) {
			this.seriesviewconfiguration = JSON.parse(JSON.stringify(this.defaultSeriesViewConfig));
			this.radioButtonsEnabled =
				this.seriesviewconfiguration &&
				this.seriesviewconfiguration.radioButtonGroup &&
				this.seriesviewconfiguration.radioButtonGroup.length > 0;
			this.selectedRadioButtonId = this.seriesviewconfiguration.defaultRadioButtonSelected;
			this.defaultRadioButtons = this.seriesviewconfiguration.radioButtonGroup;
		}

		if (this.filterSeries) {
			this.seriesviewconfiguration.radioButtonGroup = _.filter(this.defaultRadioButtons, (button: any) => {
				return !this.filterSeries.includes(button.displayName);
			});
		}

		this.chartConfig.chartConfig.series.filter((metric) => {
			if (metric.type == 'spline' && this.chartdata.length > 1) return (metric.marker.enabled = false);
			else if (metric.type == 'spline' && this.chartdata.length == 1) return (metric.marker.enabled = true);
		});
	}

	requestData(): void {
		if (this.requestwidgetdata) {
			this.showLoad = true;
			this.hasData = false;
			this.resetChartConfig();

			if (this.requestSubscription) {
				this.requestSubscription.unsubscribe();
			}
			this.requestSubscription = this.analyticsService
				.processProductsRequest(this.key, this.columns, this.currentProduct)
				.subscribe((response: any) => {
					this.showLoad = false;
					if (response.success) {
						this.hasData = true;
						this.data = response.data;
						this.selectedRadioButtonId =
							this.selectedRadioButtonId !== undefined
								? this.selectedRadioButtonId
								: this.seriesviewconfiguration.defaultRadioButtonSelected;
						this.updateChartData();
					} else {
						this.data = [];
						this.hasData = false;
					}
				});
		}
	}

	// function to update chart data depending upon filter
	updateChartData(type?: string): void {
		switch (type) {
			case 'days':
				this.enableButton('days');
				this.chartdata = this.data && this.data.days ? this.data.days : [];
				break;
			case 'weeks':
				this.enableButton('weeks');
				this.chartdata = this.data && this.data.weeks ? this.data.weeks : [];
				break;
			case 'months':
				this.enableButton('months');
				this.chartdata = this.data && this.data.months ? this.data.months : [];
				break;
			default:
				this.enableButton('days');
				this.resetChartConfig();
				this.chartdata = this.data && this.data.days ? this.data.days : [];
		}

		if (this.chartdata.length) {
			this.applyNodata = false;
			this.hasData = true;
		} else {
			this.applyNodata = true;
			this.hasData = false;
		}
		this.chartConfig.chartConfig.series.filter((metric) => {
			if (metric.type == 'spline' && this.chartdata.length > 1) return (metric.marker.enabled = false);
			else if (metric.type == 'spline' && this.chartdata.length == 1) return (metric.marker.enabled = true);
		});
		// set navigator date range
		this.setChartConfig(type);
	}

	// enabling given button and disabling other button
	enableButton(type: string): void {
		Object.keys(this.buttons).forEach((val) => (this.buttons[val] = false));
		this.buttons[type] = true;
	}

	// set date range of one month or date range selected whatever is less
	setChartConfig(type: string = 'days'): void {
		const chartConfiguration = this.chartConfig;
		if (chartConfiguration && chartConfiguration.chartConfig.xAxis && chartConfiguration.chartConfig.xAxis[0]) {
			this.selectedRadioButtonId = this.seriesviewconfiguration.defaultRadioButtonSelected;
			this.updateSeriesVisibilityByRadioButton(this.seriesviewconfiguration.defaultRadioButtonSelected);
			if (this.filterSeries) {
				this.seriesviewconfiguration.radioButtonGroup = _.filter(this.defaultRadioButtons, (button: any) => {
					return !this.filterSeries.includes(button.displayName);
				});
			} else {
				this.seriesviewconfiguration.radioButtonGroup = this.defaultRadioButtons;
			}
			// adding units to all the series
			if (chartConfiguration.chartConfig.xAxis[0].units) {
				chartConfiguration.chartConfig.series.forEach((series: any) => {
					series.dataGrouping = { units: this.units[type] };
				});
			}
			this.chartConfig = { ...chartConfiguration };
		}
	}

	// updating chart series visible flag to false on radio selection
	updateSeriesVisibilityByRadioButton(radioButtonId: any): void {
		const chartConfiguration = this.chartConfig;
		this.selectedRadioButtonId = parseInt(radioButtonId, 10);
		this.seriesviewconfiguration.radioButtonGroup.forEach((radioButtonConfig, index) => {
			// tslint:disable-next-line:only-arrow-functions typedef
			chartConfiguration.chartConfig.series.forEach(function (seriesConfig): void {
				if (radioButtonConfig.seriesId === seriesConfig['id']) {
					seriesConfig['visible'] = parseInt(radioButtonId, 10) === parseInt(index, 10);
				}
			});
		});
		this.chartConfig = { ...chartConfiguration };
	}

	// toggle series visible
	toggleSeriesVisiblityByCheckbox(id: string): void {
		this.seriesviewconfiguration.checkboxButtons.forEach((checkboxButton) => {
			checkboxButton.visible = checkboxButton.seriesId === id ? !checkboxButton.visible : checkboxButton.visible;
		});
		const chartConfiguration = this.chartConfig;
		chartConfiguration.chartConfig.series.forEach((series: any) => {
			if (id === series.id) {
				series['visible'] = !series.visible;
			}
		});
		this.chartConfig = { ...chartConfiguration };
	}

	ngOnDestroy() {
		this.chartdata = [];
		super.ngOnDestroy();
	}
}
